import {
  IChangeFeedbackStatusDTO,
  IDeleteFeedbackDTO,
  IGetFeedbacksDTO,
  IGetFeedbacksResponse,
  FeedbackEndpoints,
  IChangeFeedbackStatusResponse,
  IGetNewFeedbacksCountResponse,
} from '@/models/feedback.model';
import { IManagersListResponse } from '@/models/admins.model';
import { ApiResponse, httpClient } from '@/utils';

class FeedbacksAPI {
  static getFeedbacks({ type, ...params }: IGetFeedbacksDTO): ApiResponse<IGetFeedbacksResponse> {
    return httpClient.get<IGetFeedbacksResponse>(`${FeedbackEndpoints.FEEDBACKS}/${type}`, { params });
  }

  static getNewFeedbacksCount(): ApiResponse<IGetNewFeedbacksCountResponse> {
    return httpClient.get<IGetNewFeedbacksCountResponse>(`${FeedbackEndpoints.FEEDBACKS}/new-count`);
  }

  static getManagersList(): ApiResponse<IManagersListResponse> {
    return httpClient.get<IManagersListResponse>(FeedbackEndpoints.MANAGERS);
  }

  static changeFeedbackStatus({ id, ...data }: IChangeFeedbackStatusDTO): ApiResponse<IChangeFeedbackStatusResponse> {
    return httpClient.put<IChangeFeedbackStatusResponse>(`${FeedbackEndpoints.FEEDBACKS}/${id}`, data);
  }

  static deleteFeedback({ id }: IDeleteFeedbackDTO): ApiResponse<void> {
    return httpClient.delete(`${FeedbackEndpoints.FEEDBACKS}/${id}`);
  }
}

export default FeedbacksAPI;
